<template>
    <div class="container min-w margin-a" v-cloak>
        <div is='titlebox' :nav='JSON.parse(nav)'></div>
        <div class="content min-h">
            <div class="banner-w">
                <div is='phoneBooksSFQ'></div>
            </div>
            <div class="f-row-l wrap">
                <div v-for="(item,ind) in phones" :key='ind' class="item pinter" @click="$util.goPage('phoneBooksDetail', 7, item.id)">
                    <el-image fit='cover' :src='$fileAccessHttpUrl(item.breviaryMap)' class="img1"></el-image>
                    <div class="cont">
                        <div :title="item.pictureTitle" class="overf-elli">{{ item.pictureTitle ? item.pictureTitle : '' }}</div>
                    </div>
                </div>
            </div>


        </div>
        <!-- 分页 -->
        <div class="block f-row-c">
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="param.pageNo"
              :page-size="param.pageSize"
              layout="prev, pager, next, jumper"
              :total="param.total">
          </el-pagination>
        </div>
    </div>
</template>

<script>
import phoneBooksSFQ from '@/components/phoneBooks/phoneBooksSFQ.vue';
export default {
    components:{phoneBooksSFQ},
    computed: {
        nav: function () {
        var type = this.$route.query.type
        var arr=[
            { label: '青春风采', path: '/phoneBooksList', type: type },
        ]
        return JSON.stringify(arr)
        }
    },
    name: 'phoneBooksList',
    data() {
        return {
            phones:[],
            param:{
                pageNo:1,//分页
                pageSize:12,
                total: 0,
                // isTop:1,
            },
            page:false,
        };
    },
    created(){
        this.getList()
    },
    mounted() {

    },

    methods: {
        handleSizeChange(val) {
            this.$util.goTop()
            console.log(`每页 ${val} 条`);
            this.param.pageSize = val;
            this.getList()
        },
        handleCurrentChange(val) {
            this.$util.goTop()
            console.log(`当前页: ${val}`);
            this.param.pageNo = val;
            this.getList()
        },
        getList(){
            this.$get('/web/home/getLasBatchLists',this.param).then(res=>{
               this.phones=res.result.records;
               this.param.total= res.result.total
               this.$emit('phoneLen',this.phones.length);
               if(this.phones.length<this.param.pageSize){
                   this.page=true
               }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.container{
    background: #ffffff;
    .banner-w{
        margin-bottom: 50px;
    }
    .banner-w ,.iframebox{
        width: 100%;
        height: 444px;
    }
    .content{
        width: 100%;
        box-sizing: border-box;
        padding: 40px 50px 50px;
        .box{
            box-sizing: border-box;
        }
        .item{
            width: calc(33.33% - 7px);
            margin-left: 10px;
            margin-bottom: 10px;
            position: relative;
            overflow: hidden;
            .img1{
                width:100%;
                height: 219px;
            }
            .cont{
                position: absolute;
                text-align: center;
                width: 100%;
                height: 53px;
                line-height: 53px;
                background: rgba(#000000, 0.6);
                font-size: 18px;
                font-weight: 400;
                color: #ffffff;
                bottom: 0px;
                left: 0px;
            }
        }
        .item:nth-child(3n+1){
            margin-left: 0px;
        }
        .item:hover{
            .img1{
                transform: scale(1.2);
            }
            .cont div{
                transform: scale(1.2);
            }
        }
    }
    .block{
        margin-top: 30px;
        margin-bottom: 30px;
    }
}
</style>
